import React, { forwardRef } from "react";
import { InvoiceA4 } from "./InvoiceA4";
import { InvoiceData } from "./Printtype";

type Props = { invoices: InvoiceData[] };

const InvoicesToPrint = forwardRef<HTMLDivElement, Props>(({ invoices }, ref) => {
  return (
    <div ref={ref as any}>
      {invoices.map((inv, i) => (
        <div key={i} className={i < invoices.length - 1 ? "page-break" : ""}>
            <InvoiceA4 data={inv} />
        </div>
      ))}
    </div>
  );
});

export default InvoicesToPrint;
